/*
 *   File : userDetail.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : User Detail Card
 *   Integrations : null
 *   Version : 1.0.0
 *   Created : 14-12-2021
 */

/*import packages*/
import React, { useEffect, useRef, useState } from 'react';

/*Style Import*/
import styles from '../../styles/components/userDetail.module.scss';
import { Modal } from 'bootstrap';
import { InvestmentBreakdownTooltip } from '../badge';
import { PrimaryBtn, SecondaryBtn } from '../cta';
import APIPost from '../../services/postApi';
import { Toast } from '../note';
import devconfig from '../../config/config';

/* import components */
// import { IconStyleToolTip } from '../badge';

/* import assets */
// import Icon from '../../assets/images/dataFormating/Icon.svg'

const UserDetail = (props) => {
	const wrapperRef = useRef(null);
	const [tooltip, setTooltip] = useState(false);
	const [loader, setLoader] = useState(false);
	const [message, setMessage] = useState(null);
	const [error, setError] = useState(null);

	/* ----- closing tooltip on mouse click in any other position of screen ----*/
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		document.addEventListener('mouseup', closeMenu);
		return () => {
			document.removeEventListener('mouseup', closeMenu);
		};
	}, []);

	const closeMenu = (event) => {
		if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
			setTooltip(false)
		}
	}

	const _openBlockUserModal = () => {
		const modal = new Modal(document.getElementById("Confirm"), {});
		modal.show();
	}

	const _resetLimit = () => {
		setLoader(true);
		let url = devconfig.admin + '/user/reset-user';
		let data = JSON.stringify({
			"user_id": props.userId,
		});
		APIPost(url, data).then((response) => {
			if (response.status) {
				setMessage('Limit has been successfully reset');
			} else {
				setError(response.message);
			}
			setLoader(false);
		})
	}


	return (
		<div className={`${styles.e_user_detail_card} card position-relative`} style={{ zIndex: 10 }}>
			<div className="row ">
				{false && <div className="col-lg-3 col-3 ">
					<div className='row'>
						{/* <div className='col-5'>
							<span className={`${styles.e_profile_img}`}>
								{
									props.data.overview && props.data.overview.name && props.data ?
										props.data.overview.name[0].toUpperCase()
										:
										null
								}
							</span>
						</div> */}
						<div className='col-12'>

							<span className={`${styles.e_span} pt-4 mt-1`}>
								{
									props.data.overview && props.data.overview.name && props.data ?
										<h4 className='pt-3'>{props.data.overview.name}</h4>
										:
										null
								}

							</span>
						</div>
						<div className="col-lg-10 col-4 ">
							<h5 className={`${styles.e_detail_title} mb-3`}>Status</h5>
							{
								props.data.overview.signup_progress ?
									<p className={`${styles.e_detail_sub_title}`}>{props.data.overview.signup_progress}</p>
									:
									null
							}
						</div>
						<div className="col-lg-1 col-4 ">

						</div>
					</div>
				</div>}
				<div className={`col-lg-12 col-12 `} >
					{/* Reset limit & Block buttons moved to client name (breadcrumb) row in containers/users/detail.js */}
					{/* <div className='d-flex justify-content-end align-items-center mb-3'>
						<SecondaryBtn name={loader ? "Loading..." : "Reset limit"}
							className={loader ? "e-disabled p-2 me-2" : "p-2 me-2"}
							handleClick={_resetLimit} />
						<h5 className={`${styles.e_detail_title} mb-1 e-hand text-end cursor-pointer`} onClick={_openBlockUserModal}>{props.data.overview.is_blocked ? "🚫 Unblock" : "✅ Block"}</h5>
					</div> */}
					{
						props.data && props.data.investment_summary ?
							<div className="row">
								{/* Investments */}
								<div className="col-lg-3 col-md-6 mb-3">
									<div className={`${styles.e_accordion_body_wrapper} h-100 position-relative`}>
										<h5 className={`${styles.e_detail_title} position-relative`}>
											Investments
											<img src={require("../../assets/images/dataFormating/Icon.png").default}
												alt="Icon"
												className='ms-2'
												style={{ cursor: "pointer" }}
												onMouseEnter={() => setTooltip(true)}
												onMouseLeave={() => setTooltip(false)} />
										</h5>
										{
											tooltip ?
												<InvestmentBreakdownTooltip
													className="e-current-tooltip mt-3"
													data={{
														invested_amount: props.data.investment_summary.invested_amount,
														total_redemption: props.data.investment_summary.total_redemption,
														redemption_from_rebalance: props.data.investment_summary.redemption_from_rebalance,
														normal_redemption: props.data.investment_summary.normal_redemption,
														external_redemption: props.data.investment_summary.external_redemption,
													}} />
												:
												null
										}
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>Current</span>
											<span style={{ color: "green" }} className={`${styles.e_card_value}`}>{props.data.investment_summary.current_value}</span>
										</div>
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>Invested</span>
											<span className={`${styles.e_card_value}`}>{props.data.investment_summary.invested_amount}</span>
										</div>
									</div>
								</div>

								{/* Profit/Loss */}
								<div className="col-lg-3 col-md-6 mb-3">
									<div className={`${styles.e_accordion_body_wrapper} h-100`}>
										<h5 className={`${styles.e_detail_title}`}>Profit/Loss</h5>
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>Unrealized</span>
											<span className={`${styles.e_card_value}`}>{props.data.investment_summary.unrealized_gain ?? '-'}</span>
										</div>
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>Realized</span>
											<span className={`${styles.e_card_value}`}>{props.data.investment_summary.realised_gain ?? '-'}</span>
										</div>
									</div>
								</div>

								{/* Profit/Loss % */}
								<div className="col-lg-3 col-md-6 mb-3">
									<div className={`${styles.e_accordion_body_wrapper} h-100`}>
										<h5 className={`${styles.e_detail_title}`}>Profit/Loss %</h5>
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>XIRR</span>
											<span className={`${styles.e_card_value}`}>{props.data.investment_summary.xirr ?? '-'}</span>
										</div>
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>Absolute</span>
											<span className={`${styles.e_card_value}`}>{props.data.investment_summary.returns_percentage ?? '-'}</span>
										</div>
									</div>
								</div>

								{/* Amount In Processing */}
								<div className="col-lg-3 col-md-6 mb-3">
									<div className={`${styles.e_accordion_body_wrapper} h-100`}>
										<h5 className={`${styles.e_detail_title}`}>Amount In Processing</h5>
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>Lumpsum</span>
											<span className={`${styles.e_card_value}`}>{props.data.investment_summary.lumpsum_processing_amount_text ?? '-'}</span>
										</div>
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>SIP</span>
											<span className={`${styles.e_card_value}`}>{props.data.investment_summary.sip_processing_amount_text ?? '-'}</span>
										</div>
										<div className={`${styles.e_card_row} d-flex justify-content-between align-items-center`}>
											<span className={`${styles.e_card_label}`}>Withdrawal</span>
											<span className={`${styles.e_card_value}`}>{props.data.investment_summary.withdrawal_processing_amount_text ?? '-'}</span>
										</div>
									</div>
								</div>
							</div>
							:
							null
					}

				</div>

			</div>
			{
				message !== null ?
					<Toast data={message}
						type="success"
						id="2" />
					:
					null
			}

			{
				error !== null ?
					<Toast data={error}
						type="error"
						id="1" />
					:
					null
			}
		</div>
	)
}

export default UserDetail